import { ActionsUnion, createAction } from "store/helper";

import { createEntityActionNames, createEntityActions } from "../actions";

import { ICannedResponse, ISyncDeleteCannedResponsePayload } from "./interfaces";

export const CannedResponseActionNames = {
  CANNED_RESPONSE_ADDED: "ENTITIES/CANNED_RESPONSES/CANNED_RESPONSE_ADDED",
  CANNED_RESPONSE_REMOVED: "ENTITIES/CANNED_RESPONSES/CANNED_RESPONSE_REMOVED",
  SYNC_PATCH: "ENTITIES/CANNED_RESPONSES/SYNC_PATCH",
  SYNC_DELETE: "ENTITIES/CANNED_RESPONSES/SYNC_DELETE",
  REMOVE_ATTACHMENT: "ENTITIES/CANNED_RESPONSES/REMOVE_ATTACHMENT",
};

export const CANNED_RESPONSE = {
  ...createEntityActionNames("CANNED_RESPONSE"),
};

export const CannedResponseActions = {
  ...createEntityActions<ICannedResponse>(CANNED_RESPONSE),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: ISyncDeleteCannedResponsePayload) =>
    createAction(CannedResponseActionNames.SYNC_DELETE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeAttachment: (id: string, attachmentIndex: number) =>
    createAction(CannedResponseActionNames.REMOVE_ATTACHMENT, { id, attachmentIndex }),
};

export type CannedResponseAction = ActionsUnion<typeof CannedResponseActions>;
